export default (theme) => ({
    root: {},
    contentBox: {
        margin: '25px 40px 0 40px',
        padding: '25px 30px',
        border: '1px solid $fmPlaceholders',
        backgroundColor: theme.colors.actionMinor[50],
        textAlign: 'left',
    },
    contentBoxText: {
        display: 'flex',
        alignItems: 'center',
    },
    '@keyframes rotation': {
        from: {
            transform: 'rotate(359deg)',
        },
        to: {
            transform: 'rotate(0deg)',
        },
    },
    contentBoxIcon: {
        marginRight: 3,
        animation: '$rotation 2s infinite linear',
    },
    contentBoxBar: {
        margin: '12px 0',
    },
});
